import { Switch, Route, Redirect } from 'react-router';
import RoutesTracking from './lists/tracking';
import RoutesHistory from './lists/history';
import RoutesPrep from './lists/preparation';
import NewJourney from './NewJourney';
import JourneyTemplates from './templates';

export interface Option {
  value: number | string;
  name: string;
}

export default function JourneysList() {
  return (
    <Switch>
      <Route path="/journeys/draft" component={RoutesPrep} />
      <Route path="/journeys/active" component={RoutesTracking} />
      <Route path="/journeys/history" component={RoutesHistory} />
      <Route path="/journeys/new/:kind" render={() => <NewJourney />} />
      <Route path="/journeys/templates" component={JourneyTemplates} />
      <Redirect to="/journeys/active" />
    </Switch>
  );
}
